import { stats } from "@/mocks/services";

export default function TrustBar() {
  return (
    <section className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-10 py-10 md:py-14 grid grid-cols-2 md:grid-cols-4 gap-6">
        {stats.map((s) => (
          <div key={s.label} className="text-center md:text-left border-l-2 border-accent-500 pl-4 md:pl-6">
            <div className="font-heading text-3xl md:text-5xl text-background-50">
              {s.value}
              <span className="text-accent-400 text-xl md:text-2xl ml-1">{s.suffix}</span>
            </div>
            <div className="text-xs md:text-sm text-background-200 mt-1 tracking-wider">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}